<!--The content below is only a placeholder and can be replaced.-->
<div fxLayout="column" fxFill>
  <mat-card fxFill>
    <router-outlet></router-outlet>
  </mat-card>
</div>